export default __webpack_public_path__ + "fonts/Agipo-Bold.woff2";